import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton, SkeletonFields, SkeletonGroup, SkeletonPage, SkeletonRows } from '@/components/ui/skeleton'
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { TableSkeletonRows } from '@/components/ui/table-skeleton'
import { Demo, DsSection } from '../primitives'

export function SkeletonsSection() {
  return (
    <DsSection
      id="skeletons"
      title="Skeletons"
      intro={
        <>
          Content that is still loading gets a skeleton in the shape of the thing that is coming, never a
          spinner. Spinners are reserved for actions in flight — the <code>loading</code> prop on{' '}
          <code>&lt;Button&gt;</code>, an inline &ldquo;loading more&rdquo; indicator, or an auth redirect
          gate.
          <br />
          <br />
          <code>SkeletonRows</code>, <code>SkeletonFields</code> and <code>SkeletonGroup</code> are{' '}
          <code>role=&quot;status&quot;</code> regions, so the loading state is announced. A bare{' '}
          <code>Skeleton</code> is a silent pulsing div — if you hand-compose a loading branch out of them,
          wrap it in <code>SkeletonGroup</code> or a screen-reader user gets no signal at all.
        </>
      }
    >
      <Demo label="Table — TableSkeletonRows inside the real TableBody, so headers stay put" consoleOnly>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="font-semibold">Name</TableHead>
              <TableHead className="font-semibold">Status</TableHead>
              <TableHead className="font-semibold">Users</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableSkeletonRows columns={3} rows={4} />
          </TableBody>
        </Table>
      </Demo>

      <Demo label="List or table body you do not own — SkeletonRows">
        <Card>
          <CardHeader>
            <CardTitle>Documents</CardTitle>
          </CardHeader>
          <CardContent>
            <SkeletonRows rows={4} />
          </CardContent>
        </Card>
      </Demo>

      <Demo label="Definition list — SkeletonFields">
        <Card>
          <CardHeader>
            <CardTitle>Carrier Info</CardTitle>
          </CardHeader>
          <CardContent>
            <SkeletonFields fields={4} />
          </CardContent>
        </Card>
      </Demo>

      <Demo label="A whole page, with or without its rail — SkeletonPage rail">
        <div className="border-ink-100 h-80 overflow-hidden rounded-md border">
          <SkeletonPage rail />
        </div>
      </Demo>

      <Demo label="Anything else — compose Skeleton inside a SkeletonGroup">
        <SkeletonGroup className="flex flex-col gap-3">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-40 w-full" />
        </SkeletonGroup>
      </Demo>
    </DsSection>
  )
}
